import StoreManagement from '@components/addStore/StoreManagement';
import React from 'react';

const AddStore = () => {
  return (
    <div id="add_store_container">
      <StoreManagement />
    </div>
  );
};

export default AddStore;
